import { Card } from "./vendor/Card/main.js";
import { ListLoader } from "./vendor/ListLoader/main.js";

/**
 * `CardLoader` is a loading spinner that looks like a `Card`.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @see {@link Card}
 */
export const CardLoader = () => (
  <Card>
    <ListLoader />
  </Card>
);
